/**
 * 项目档案实体
 */

import { useState, useEffect } from 'react';
import {
    ConfigProvider,
    message,
    Modal,
    Button,
    Timeline,
    Row,
    Col,
    Progress,
    Tag,
    Statistic,
} from 'antd';
import $ from 'jquery';
import { ClockCircleOutlined } from '@ant-design/icons';
import {
    locale,
    AddRequestHeaders,
    UjoinParams,
    Html2pdf,
} from '../../incs/FunHelper';
import CNF from '../../incs/Config';

import XZTLOGO from '../../images/logo_head.png';
import PAGEHEADERRIGHT from '../../images/page-header-right.png';

const twoColors = {
    '0%': '#108ee9',
    '100%': '#87d068',
};

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [open, setOpen] = useState(false);
    const [data, setData] = useState([]);

    useEffect(() => {
        setOpen(props.open);
    }, [props]);

    useEffect(() => {
        // 获取项目进度日志
        const params = {
            'rss': 'list',
            'project_ulid': props.record.key,
            'start_date': '',
            'end_date': '',
        };
        $.ajax({
            url: `${CNF.api}project/progressLogs${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        let newData = [];
                        var initPhase = '';
                        for (let i = 0; i < data.dat.length; i++) {
                            let item = data.dat[i];
                            let children = ''
                            children += item.record_time + ': '
                            children += '进度' + item.progress + '%, '
                            children += item.description;
                            let obj = {
                                children: children,
                                color: item.node_color,
                            }
                            // 每个阶段打上时间标签
                            if (item.phase !== initPhase) {
                                console.log('item.phase', item.phase);
                                obj.dot = (
                                    <ClockCircleOutlined style={{ fontSize: '16px', }} />
                                )
                                initPhase = item.phase;
                            }
                            newData.push(obj);
                        }
                        setData(newData);
                    } else {
                        setData([]);
                    }
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }, [props.record, messageApi]);

    const printer = () => {
        var printContents = document.getElementById('print-info-id').innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
        window.location.reload();
    };

    const download = () => { Html2pdf('print-info-id', props.record.name + '.' + props.record.date, false); };


    const cancel = () => {
        setOpen(false);
        setData([]);
    };


    return <ConfigProvider
        locale={locale}
        theme={{
            token: {
                colorPrimary: global.THEMECOLOR,
            },
        }}
    >
        {contextHolder}
        <Modal
            width={820}
            style={{ top: 0 }}
            closable={false}
            open={open}
            keyboard={true}
            maskClosable={true}
            onCancel={cancel}
            footer={[
                <Button key='back' onClick={cancel}>取消</Button>,
                <Button key='printer' type='primary' onClick={printer}>打印</Button>,
                <Button key='link' type='primary' onClick={download} style={{ marginRight: 20 }}>下载</Button>,
            ]}
        >
            <div id='print-info-id'>
                <div className='print-info' style={{ padding: '0 30px' }}>
                    <Row style={{ margin: '10px' }}>
                        <Col span={2}><img src={XZTLOGO} height='45px' alt={CNF.companyShortName} /></Col>
                        <Col span={22} align='right'><img src={PAGEHEADERRIGHT} height='35px' alt={CNF.companyShortName} /></Col>
                    </Row>
                    <table width='100%'>
                        <thead align='center'>
                            <tr>
                                <th colSpan='24'><h2>{props.record.name}</h2></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan='4' style={{ width: 120 }}>项目编号</td><td colSpan='8' style={{ width: 240 }}>{props.record.number}</td>
                                <td colSpan='4' style={{ width: 120 }}>项目进度</td><td colSpan='8' style={{ width: 240 }}><Progress
                                    style={{ margin: 0 }}
                                    size='small' percent={props.record.progress} strokeColor={twoColors} /></td>
                            </tr>
                            <tr>
                                <td colSpan='4' style={{ width: 120 }}>合同金额</td><td colSpan='8' style={{ width: 240 }}><Tag color='green'><Statistic precision={CNF.DPL} suffix={props.record.contract_amount > 10000 ? '万元' : '元'} valueStyle={{ fontSize: CNF.fontSize - 2, color: 'green' }} value={props.record.contract_amount >= 10000 ? props.record.contract_amount / 10000 : props.record.contract_amount} /></Tag></td>
                                <td colSpan='4' style={{ width: 120 }}>签订日期</td><td colSpan='8' style={{ width: 240 }}>{props.record.contract_date}</td>
                            </tr>
                            <tr>
                                <td colSpan='4' style={{ width: 120 }}>项目类型</td><td colSpan='8' style={{ width: 240 }}>{props.record.type}</td>
                                <td colSpan='4' style={{ width: 120 }}>项目阶段</td><td colSpan='8' style={{ width: 240 }}>{props.record.phase}</td>
                            </tr>
                            <tr><td colSpan='4' style={{ width: 120 }}>备注:</td><td colSpan='19' style={{ width: 600 }}>
                                {props.record.description && props.record.description.split('\n').map((item, index) => {
                                    return <p key={index} style={{ margin: 0 }}>{item}</p>;
                                })}
                            </td></tr>
                        </tbody>
                    </table>
                    <Timeline
                        style={{ marginTop: 20 }}
                        mode='left'
                        items={data}
                    />
                </div>
            </div>
        </Modal>
    </ConfigProvider>
}

export default Entity